import { AutoStoriesOutlined } from "@mui/icons-material";
import { Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function NotFound(){
  const { t } = useTranslation();

  return (
    <Box sx={{
      mx: 'auto',
      p: 3,
      textAlign: 'center',
      alignSelf: 'center',
    }}>
      <AutoStoriesOutlined sx={{
        fontSize: 100,
        opacity: 0.5
      }}/>
      <Typography variant='h4'>
        {t('sys:order_not_found')}
      </Typography>
    </Box>
  )
}